import React from "react";
import { fetchQuery, graphql } from "react-relay";

import { useGroupEmitter } from "~/lib/websocket";
import { environment } from "~/models";

export function useCalendarsRefetchSocket(userId: string) {
	const socket = useGroupEmitter(`user.${userId.replace(/=/g, "")}`);

	React.useEffect(() => {
		function onSocketMessage(event: { type: string }) {
			if (event.type === "CALENDARS_UPDATED") {
				fetchQuery(
					environment,
					graphql`
						query useCalendarsRefetchSocketQuery {
							viewer {
								...EventsCalendars @relay(mask: false)
							}
						}
					`,
					{},
				).toPromise();
			}
		}

		socket.on("message", onSocketMessage);
		return () => socket.off("message", onSocketMessage);
	}, [socket]);
}
